import { createContext, useContext } from "react";

export const DashboardDataContext = createContext({
  queryData: {},
  globalState: {},
  setGlobalState: () => {},
  effectiveCss: "",
  effectiveTemplate: "",
  componentContent: new Map(),
  setComponentContent: () => {},
  setQueryData: () => {},
});

export const useDashboardData = () => useContext(DashboardDataContext);
